module.exports = __webpack_public_path__ + "media/images/dividend/ill-beach-mobile@2x-6bee964ecc01f41a0c91472195ee4abc.png";